<template>
  <div>
    <!-- Delete Reason or Mode -->
    <b-modal
      :id="'delete_reason_mode_ConfirmModal' + rowData.id"
      scrollable
      hide-header
      hide-footer
      size="lg"
      no-close-on-esc
      :ref="'delete_reason_mode_ConfirmModal' + rowData.id"
    >
      <VpConfirmModal :modalId="'delete_reason_mode_ConfirmModal' + rowData.id">
        <template v-slot:title>
          <span>{{ $t('common.delete') }} {{ row == "reason" ? "Reason" : $t('attendanceModes.attendanceMode') }}</span>
        </template>

        <template v-slot:text1>
          <span>
            {{ $t('common.notes.areYouSureYouWant') }}
            <strong class="strong-txt">“{{ $t('common.delete') }}”</strong> {{ $t('common.notes.this') }} {{ row == "reason" ? $t('attendanceModes.reason.reason') : $t('attendanceModes.attendanceModeForModal') }}{{ $t('common.questionMark') }}
          </span>
        </template>

        <template v-slot:text2 v-if="row == 'mode'">
          <span>
            {{ $t('attendanceModes.grid.byDeletingThisModeAllTheRelatedReasonsWillBeDeleted') }}
          </span>
        </template>

        <template v-slot:buttons>
          <VpButton :text="$t('common.cancel')" @click="hideModal('delete_reason_mode_ConfirmModal' + rowData.id)" />
          <VpButton :text="$t('common.delete')" :disabled="isLoading" :isLoading="isLoading" :isDanger="true" @click="deleteReasonOrMode()" />
        </template>
      </VpConfirmModal>
    </b-modal>

    <DxDropDownButton
      :items="items"
      :drop-down-options="{ width: 141.41, maxHeight: 179 }"
      :scrollable="true"
      :text="$t('common.grid.selectActions')"
      id="mode-select"
      class="selectActions"
      itemTemplate="actionsTemp"
    >
      <template #actionsTemp="{ data }">
        <div
        :class="{ 'reason-actions-seperator' : data.type == 'reason' && data.text != items.filter((item) => item.visible)[items.filter((item) => item.visible).length - 1].text,
          'mode-actions-seperator' : data.type == 'mode' && data.text != items.filter((item) => item.visible)[items.filter((item) => item.visible).length - 1].text,}"
          class="dropdown-wrapper"
          title=""
          v-b-modal="data.modalId ? data.modalId : null"
          @click="!data.modalId ? redirectTo(data) : ''"
        >
          <div class="dropdown-items" :class="{ 'red-remove': data.id == 'deleteMode' || data.id == 'deleteReason' }" title="">
            {{ data.text }}
          </div>
        </div>
      </template>
    </DxDropDownButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxDropDownButton from "devextreme-vue/drop-down-button";

export default {
  components: {
    DxDropDownButton,
  },
  props: ["row", "rowData"],
  data() {
    return {
      items: [],
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters("attendanceMode", ["getAttendanceModes"]),
  },

  beforeMount() {
    this.items =
      this.row == "mode"
        ? [ {
              text: this.$t('attendanceModes.grid.editMode'),
              id: "editMode",
              visible: true,
              type : 'reason'
            },
            {
              text: this.$t('attendanceModes.grid.deleteMode'),
              id: "deleteMode",
              modalId: "delete_reason_mode_ConfirmModal" + this.rowData.id,
              visible: !this.rowData.has_flow,
              type : 'mode'
            },
            {
              text: this.$t('attendanceModes.grid.addReason'),
              id: "addReason",
              visible: !this.rowData.are_attendance_codes_used,
              type : 'reason'
            },
          ]
        : [
            { text: this.$t('attendanceModes.grid.editReason'), id: "editReason", visible: true, type :'reason' },
            {
              text: this.$t('attendanceModes.grid.deleteReason'),
              id: "deleteReason",
              modalId: "delete_reason_mode_ConfirmModal" + this.rowData.id,
              visible: true,
              type :'reason'
            },
          ];
  },

  watch: {},

  methods: {
    ...mapActions("attendanceMode", ["deleteModeOrReason"]),

    redirectTo(data) {
      if (data.id == "editReason") {
        this.$router.push({
          path: "/add-reason",
          query: {
            id: this.rowData.id,
            attendance_mode_id: this.rowData.mod_Parent_ID,
            reason_name: this.rowData.name,
            presented: this.rowData.presented,
            reason_type: this.rowData.type,
            duration: this.rowData.duration == "-" ? null : this.rowData.duration,
            from_time: this.rowData.from_time,
            to_time: this.rowData.to_time,
            attendance_codes: JSON.stringify(this.rowData.attendance_codes),
          },
        });
      }else if(data.id == "editMode"){
        this.$router.push({
          path: "/add-Attendance-Mode",
          query : {
            id: this.rowData.id,
            name: this.rowData.name,
            integration_name: this.rowData.integration_name,
            working_days: JSON.stringify(this.rowData.working_days),
            from_time: this.rowData.from_time,
            to_time: this.rowData.to_time,
            integration_id: this.rowData.integration_id,
            attendance_codes : JSON.stringify(this.rowData.attendance_codes),
            settings : JSON.stringify(this.rowData.settings),
            has_reasons : this.rowData.has_reasons,
          }
        });
      } else {
        this.$router.push({
          path: "/add-reason",
          query: {
            attendance_mode_id: this.rowData.id,
          }
        });
      }
    },

    getAttendanceModeId(reasonId) {
      // console.log("attt", this.getAttendanceModes);
      let modeIndex;
      this.getAttendanceModes.map((mode, i) => {
        const reason = mode.reasons.find((reason) => reason.id == reasonId);
        if (reason) modeIndex = i;
      });
      // console.log("modeIndex", modeIndex);
      if (modeIndex) return this.getAttendanceModes[modeIndex].id;
    },

    hideModal(id) {
      this.$bvModal.hide(id);
    },

    deleteReasonOrMode() {
      this.isLoading = true;
      console.log("delete", this.row, this.rowData.id);
      const row = this.row == "reason" ? "reason" : "attendance_mode";
      this.deleteModeOrReason({ row, id: this.rowData.id })
      .then( async () => {
        this.isLoading = false;
        await this.$emit('refreshAfterDelete', this.rowData.id);
        await this.$bvModal.hide("delete_reason_mode_ConfirmModal" + this.rowData.id);
      })
      .catch(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.reason-actions-seperator {
  border-bottom: 1px solid #e0e0e0 !important;
}
.mode-actions-seperator {
  border-bottom: 5px solid #e0e0e0 !important;
}

.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 6px auto !important;
    max-width: 142px !important;
    white-space: normal !important;
    padding: 1px 5px 1px 5px !important;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}
</style>
